var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYesTickGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5528 0.215432C11.9891 -0.151133 11.1972 -0.0378513 10.7849 0.463582L4.38727 8.27294L2.25789 5.87214C1.82397 5.38454 1.02859 5.30155 0.48123 5.68624C-0.0678071 6.07091 -0.160205 6.78067 0.272065 7.26662L4.46765 12L12.8295 1.78889C13.2418 1.28579 13.1182 0.581997 12.5528 0.215432Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesTickGrey);
export default __webpack_public_path__ + "static/media/yes-tick-grey.f90824983bf38feacad65541bd7e64c4.svg";
export { ForwardRef as ReactComponent };